module.exports = __webpack_public_path__ + "img/logo.bd86ac47.png";